// @ts-check
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import React, { useState, useEffect, useMemo } from "react";
import { Controller, useForm } from "react-hook-form";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";

const { MIN_MAX_COPAY_STEP, MIN_MAX_DIFFERENTIAL, MIN_MAX_COPAY_DIFFERENTIAL } =
  ROUTE_PATHS;

const selectionNavigationLinks = {
  1: MIN_MAX_COPAY_STEP,
  2: MIN_MAX_DIFFERENTIAL,
  3: MIN_MAX_COPAY_DIFFERENTIAL,
};

const MinMaxList = ({
  visible,
  onHide,
  selectedRows,
  rowData,
  prevScreen,
  previousState = [],
  currentState = {},
  currentParentIndex = 0,
  paramsData = {},
  selectMode = false,
  onNavigate,
}) => {
  const { register, control, handleSubmit, setValue, setFocus } = useForm({});

  const buttonSection = useMemo(
    () => [
      {
        button_label: "Back",
        button_handeler: onHide,
        button_key: "F12",
      },
    ],
    [onHide]
  );

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        setFocus("selection");
      }, 100);
    }
  }, [setFocus, visible]);

  const header = (
    <div className="header-section">
      <ButtonsSection ctaButtons={buttonSection} align="left" />
      <div className="screen-info">
        <h1>
          {"Min/Max List"} - <span className="heading-cod">{"RCPTF009"}</span>
        </h1>
      </div>
    </div>
  );

  const [focusedInput, setFocusedInput] = useState(null);

  const navigateToPage = useCustomNavigate();

  const handleFocus = (inputName) => {
    setFocusedInput(inputName);
  };

  const onSubmit = (data) => {
    switch (data["selection"]) {
      case 1:
      case 2:
      case 3: {
        const selectedSchedules = selectedRows?.length ? selectedRows : rowData;
        if (selectMode) {
          onNavigate({
            data: rowData[0],
            target: selectionNavigationLinks[data["selection"]],
            navType: "local",
            schedulesDataKey: "selectedSchedules",
          });
        } else {
          navigateToPage(selectionNavigationLinks[data["selection"]], [
            ...previousState,
            {
              ...currentState,
              currentIndex: currentParentIndex,
              paramsData: paramsData,
              showMinMaxModel: true,
              selectedSchedules,
            },
            {
              selectedSchedules,
              previousScreen: prevScreen,
              currentIndex: 0,
            },
          ]);
        }

        onHide();
        break;
      }
      default:
        onHide();
        break;
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit(onSubmit)();
    }
  };

  const formField = {
    name: "selection",
    label: "Enter your selection",
    min: 1,
    max: 3,
  };

  const { name, label, min, max } = formField;

  return (
    <Dialog
      header={header}
      visible={visible}
      style={{ width: "40vw" }}
      onHide={onHide}
      className="min-max-list-dialog"
      closable={false}
    >
      <div className="dialog-content">
        <div className="selection_input">
          <div className="label_container">
            <label htmlFor={name} className="search_label">
              {label}
            </label>
          </div>
          <Controller
            name={name}
            control={control}
            render={({ field }) => {
              return (
                <InputNumber
                  id={name}
                  {...register(name)}
                  onChange={(e) => setValue(name, e.value)}
                  onKeyDown={handleKeyDown}
                  onFocus={() => handleFocus(name)}
                  className={
                    focusedInput === name
                      ? "p-inputtext-highlight list-selection"
                      : "list-selection"
                  }
                  style={{ textTransform: "uppercase" }}
                  min={min}
                  max={max}
                />
              );
            }}
          />
        </div>

        <div className="selection-options">
          <div className="option_container">
            <label className="search_label">1. Copay</label>
          </div>
          <div className="option_container">
            <label className="search_label">2. Differential</label>
          </div>
          <div className="option_container">
            <label className="search_label">3. Copay + Differential</label>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default MinMaxList;
